// ============================================
// スクロール表示時・ホバー時のスクランブルテキストアニメーション
// 参考；https://tane-be.co.jp/animation/hover/11/
// ============================================

// ============================================
// 設定用の変数
// ============================================
//メディアクエリ
const breakPointPc = 768;
const mql = window.matchMedia(`(min-width: ${breakPointPc}px)`);
// ランダム表示に使用する文字列
const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

// ============================================
// スクロール表示時・ホバー時のスクランブルテキストアニメーション
// ============================================
export const initScrambleAnimation = () => {

	// スクロール発火対象
	const scrollTargets = document.querySelectorAll(
		'[data-scramble-target]'
	);

	// ホバー発火対象
	const hoverTargets = document.querySelectorAll(
		'[data-scramble-hover-target]'
	);
	// TODO: ナビゲーションは特殊な処理っぽいので別ファイルに記載したほうが良いかも
	// ------------------------------------
	// l-navの各文字幅をl-fixedへ付与
	// ------------------------------------
	const syncScrambleWidth = () => {

		const navTargets = document.querySelectorAll('.l-nav [data-scramble-hover-target]');
		const fixedTargets = document.querySelectorAll('.l-fixed [data-scramble-hover-target]');

		//要素がなければスルー
		if (!navTargets.length || !fixedTargets.length) return;
		// SPはスルー
		if (!document.body.classList.contains('is-width-pc')) return;


		navTargets.forEach((navElement, index) => {

			const fixedElement = fixedTargets[index];

			if (!fixedElement) return;

			// 一旦固定幅を解除
			navElement.style.width = '';
			fixedElement.style.width = '';

			// l-nav側の実際の横幅を取得
			const width =
				navElement.getBoundingClientRect().width;

			// スクランブル時にガタつかないよう固定
			navElement.style.display = 'inline-block';
			navElement.style.width = `${width}px`;

			// l-fixedにも同じ幅を付与
			fixedElement.style.display = 'inline-block';
			fixedElement.style.width = `${width}px`;
		});
	};

	// -------------------------
	// 横幅設定
	// -------------------------
	const updateScrambleWidth = (isPc) => {

		// PC
		if (isPc) {
			syncScrambleWidth();
			return;
		}

		// SP
		hoverTargets.forEach((element) => {

			element.style.width = '';
			element.style.display = '';
		});
	};

	// 初回
	updateScrambleWidth(mql.matches);

	// ブレイクポイント変更時
	mql.addEventListener('change', (event) => {
		updateScrambleWidth(event.matches);
	});

	// -------------------------
	// スクロールで発火
	// -------------------------
	const observer = new IntersectionObserver(
		(entries) => {

			entries.forEach((entry) => {

				if (!entry.isIntersecting) return;

				const element = entry.target;

				// 一度だけ実行
				observer.unobserve(element);

				startScramble(element);
			});
		},
		{
			threshold: 0.8,
		}
	);

	scrollTargets.forEach((element) => {
		observer.observe(element);
	});
	// -------------------------
	// 初期化設定
	// -------------------------
	[
		...scrollTargets,
		...hoverTargets
	].forEach((element) => {
		prepareScramble(element);
	});
	// -------------------------
	// ブレイクポイントが変わった瞬間に再計測
	// -------------------------
	mql.addEventListener('change', () => {
		[
			...scrollTargets,
			...hoverTargets
		].forEach((element) => {
			setCharacterWidths(element);
		});
	});
	// -------------------------
	// ホバーで発火
	// -------------------------
	hoverTargets.forEach((element) => {

		element.addEventListener('pointerenter', () => {

			// SPはスルー
			if (!document.body.classList.contains('is-width-pc')) {
				return;
			}
			const duration = element.dataset.scrambleDuration;
			// アニメーション実行
			startScramble(element, duration);
		});
	});
};
// ============================================
// 任意のタイミングで発火（importで読み込みDOM指定をして発火する）
// ============================================
export const initManualScramble = elements => {
	elements.forEach((element) => {
		const duration = element.dataset.scrambleDuration;
		prepareScramble(element);
		setCharacterWidths(element);
		startScramble(element, duration);
		// ブレイクポイント変更時
		mql.addEventListener('change', () => {
			setCharacterWidths(element);
		});
	});
};

// ============================================
// 初期設定（元文字を取得しspanタグを生成）
// ============================================
const prepareScramble = element => {
	const original = element.innerText;
	// 元テキストを保持
	const charData = [];
	element.innerHTML = '';
	for (const char of original) {
		// 改行
		if (char === '\n') {
			charData.push({
				type: 'newline'
			});
			element.appendChild(
				document.createElement('br')
			);
			continue;
		}
		const span = document.createElement('span');
		span.className = 'scramble-char';
		span.textContent = char === ' ' ? '\u00A0' : char;
		element.appendChild(span);
		charData.push({
			type: 'char',
			char,
			span
		});
	};
	element._scrambleData = charData;
};

// ============================================
// スクランブルアニメーション
// ============================================
const startScramble = (element, duration = null) => {
	// ------------------------------------
	// テキストをランダム文字から徐々に復元する
	// ------------------------------------
	// アニメーション中は再実行しない
	if (element.dataset.scrambling === 'true') return;
	element.dataset.scrambling = 'true';
	if (element._lastWidth !== element.offsetWidth) {
		setCharacterWidths(element);
		element._lastWidth = element.offsetWidth;
	}
	// 元のテキストを保持
	element.dataset.scrambling = 'true';
	const charData = element._scrambleData;
	const realChars =
		charData.filter(
			item => item.type === 'char'
		);

	// スクランブル終了秒数を指定
	let frameStep;
	if (duration) {
		const intervalTime = 30;
		const totalFrames = duration / intervalTime;
		frameStep = element.innerText.length / totalFrames;
	} else {
		frameStep = 0.4
	}

	// 復元位置管理用
	let frame = 0;
	const interval = setInterval(() => {
		realChars.forEach((item, index) => {
			// 復元済みの文字はそのまま表示
			if (index < frame) {
				item.span.textContent = item.char;
				return;
			}
			// 未復元部分はランダム文字を表示
			item.span.textContent =
				CHARS[
				Math.floor(
					Math.random() *
					CHARS.length
				)
				];
		});
		// 少しずつ復元範囲を広げる
		frame += frameStep;
		// 全文字復元したら終了
		if (frame >= realChars.length) {
			clearInterval(interval);
			realChars.forEach(item => {
				item.span.textContent = item.char;
			});
			element.dataset.scrambling = 'false';
		}
	}, 30);
}

// ============================================
// 文字幅計測用のDOM生成
// ============================================
const createMeasureEl = element => {
	const measureElement = document.createElement('span');
	const style = getComputedStyle(element);
	measureElement.style.position = 'absolute';
	measureElement.style.visibility = 'hidden';
	measureElement.style.whiteSpace = 'pre';
	measureElement.style.fontFamily = style.fontFamily;
	measureElement.style.fontSize = style.fontSize;
	measureElement.style.fontWeight = style.fontWeight;
	measureElement.style.letterSpacing = style.letterSpacing;
	return measureElement;
}
// ============================================
// 計測処理
// ============================================
// パフォーマンス改善のため2回以上出てきた以下条件のフォントは計測せず、キャッシュに保存された数値を使う
// 条件：fontFamily・fontSize・fontWeight・fontStyle・letterSpacingがすべて一致したフォント
const widthCache = new Map();
const measureWidth = (
	char,
	element,
	measureElement
) => {
	const style = getComputedStyle(element);
	const styleKey = [
		style.fontFamily,
		style.fontSize,
		style.fontWeight,
		style.fontStyle,
		style.letterSpacing
	].join('|');

	const cacheKey = `${styleKey}|${char}`;
	if (widthCache.has(cacheKey)) {
		return widthCache.get(cacheKey);
	}
	measureElement.style.fontFamily = style.fontFamily;
	measureElement.style.fontSize = style.fontSize;
	measureElement.style.fontWeight = style.fontWeight;
	measureElement.style.fontStyle = style.fontStyle;
	measureElement.style.letterSpacing = style.letterSpacing;
	measureElement.textContent = char === ' ' ? '\u00A0' : char;

	const width = measureElement.getBoundingClientRect().width;
	widthCache.set(cacheKey, width);
	return width;
};
// ============================================
// 全角判定
// ============================================
const isFullWidth = char => {
	return /[^\u0020-\u007E]/.test(char);
};
// ============================================
// 各文字のwidthを指定
// ============================================
const setCharacterWidths = element => {
	// 計測用のDOMを生成
	const measureElement = createMeasureEl(element);
	document.body.appendChild(measureElement);

	// 最大スクランブル文字幅を取得
	let maxScrambleWidth = 0;
	for (const char of CHARS) {
		maxScrambleWidth = Math.max(
			maxScrambleWidth,
			measureWidth(char, element, measureElement)
		);
	};

	// 元テキストの文字幅を取得
	const charData = element._scrambleData;
	charData.forEach((item) => {
		if (item.type !== 'char') {
			return;
		}
		const char = item.char;
		const span = item.span;
		// 元文字幅測定
		const originalWidth = measureWidth(char, element, measureElement);
		// スクランブル文字と元テキストの文字の幅を判定し数値を入れる
		// かつ全角半角で最大最小の数値を入れ替える
		let spanWidth = 0;
		if (isFullWidth(char)) {
			spanWidth = Math.max(originalWidth, maxScrambleWidth);
		}
		else {
			spanWidth = Math.min(originalWidth, maxScrambleWidth);
		}
		// ルートフォントサイズ
		const rootFontSize =
			parseFloat(
				getComputedStyle(document.documentElement).fontSize
			);
		span.style.width = `${spanWidth / rootFontSize}rem`;
		span.textContent = char === ' ' ? '\u00A0' : char;
	});

	measureElement.remove();
}